import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=05d6bc8d&"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDashboard.vue?vue&type=style&index=0&id=05d6bc8d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports